import { createAsyncThunk } from "@reduxjs/toolkit";
import { Country } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindCountry, GetCountry } from "../../country/api/interface";

export const findSelectCountry = createAsyncThunk(
  "selectCountry/findSelectCountry",
  async (values: FindCountry, { rejectWithValue }) => {
    try {
      const response = await Country.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectCountry = createAsyncThunk(
  "selectCountry/searchSelectCountry",
  async (values: FindCountry, { rejectWithValue }) => {
    try {
      const response = await Country.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectCountry = createAsyncThunk(
  'selectCountry/getSelectCountry',
  async ({ id }: GetCountry, { rejectWithValue }) => {
    try {
      const response = await Country.get(id, {});

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
